module.exports = __webpack_public_path__ + "static/media/MainBar.bd2f1a7a.png";